import { useLocation, useNavigate } from 'react-router-dom';
import { Receipt } from './Receipt';
import { Button } from '@/components/ui/button';
import { Main } from '@/components/Main';

export const ReceiptView = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { saleData } = location.state || {};

  if (!saleData) {
    return (
      <Main>
        <div className="flex flex-col items-center justify-center gap-4">
          <h2 className="text-2xl font-semibold">Comprovante não encontrado</h2>
          <Button onClick={() => navigate('/vendas')}>Voltar para Vendas</Button>
        </div>
      </Main>
    );
  }

  return (
    <Main>
      <div className="flex flex-col items-center gap-4">
        <Receipt data={saleData} />
        <Button onClick={() => navigate('/vendas')} variant="outline" className="mt-4">
          Voltar para Vendas
        </Button>
      </div>
    </Main>
  );
}; 